import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { companiesFetch } from './action';
import { selectFeatureCompany } from './selector';

export const useCompaniesFetch = () => {
  const dispatch = useDispatch();
  const { companies } = useSelector(selectFeatureCompany);

  useEffectOnce(() => {
    if (!isEmpty(companies)) return;
    dispatch(companiesFetch());
  });

  return companies;
};
